export const navigationHome = [
    { name: 'Home', to: '/' },
    { name: 'About Us', to: '/about-us' },
    { name: 'Containers', to: '/containers' },
    { name: 'Services', to: '/services' },
  ]